export default {
  faq: {
    title_small: "الأسئلة الشائعة",
    title1: "هل لديك أسئلة؟",
    title2: "نحن هنا لمساعدتك",

    q1: "ما هو ماهال؟",
    a1: "MAHAL هو منصة B2B لتوريد الأغذية تربط المطاعم بالموردين الموثوقين لتوفير مصادر شفافة وموثوقة.",

    q2: "كيف تعمل المنصة؟",
    a2: "يمكن للمطاعم تصفح الموردين، تقديم الطلبات، الدفع بأمان، واستلام التوصيلات المجدولة عبر ماهال.",

    q3: "من يمكنه الانضمام إلى ماهال؟",
    a3: "يمكن للمطاعم والموردين وشركاء الأعمال الانضمام إلى ماهاللتنمية أعمالهم.",

    q4: "هل يتوفر دعم؟",
    a4: "نعم، فريق الدعم لدينا يساعد الشركات في الانضمام وإدارة الطلبات والتنسيق للتوصيل.",

    cta: "هل لا تزال لديك أسئلة؟",
  },
};